import React from 'react';
import PropTypes from 'prop-types';
import PackageSelector from '../../js/react-components/PackageSelector';

function PackageSelectorContainer({
    selectedPackage = {},
    selectPackage = () => {},
    allPackages = {},
    currentPackage = {},
    ctaKey = '',
}) {
    const allPacks = allPackages.map((pack, i) => (
        <PackageSelector
            key={i}
            setPackage={selectPackage}
            selectedPackage={selectedPackage}
            currentPackage={currentPackage}
            packageObj={pack}
            features={ ctaKey ? pack.featuresList : []}
            ctaKey={ctaKey}
        />
    ));

    return (
        <>
            {allPacks}
        </>
    );
}

PackageSelectorContainer.propTypes = {
    selectPackage: PropTypes.func.isRequired,
    allPackages: PropTypes.array.isRequired,
    ctaKey: PropTypes.string,
    selectedPackage: PropTypes.object.isRequired,
    currentPackage: PropTypes.object,
};

export default PackageSelectorContainer;
